import usePost from 'civic-champs-shared/api/hooks/usePost'
import { useCurrentOrg } from 'auth/hooks'

export type CustomMessageFailureReason = 'do-not-contact' | 'bounced' | 'unsubscribed' | 'no-contact'

export interface NotificationBlastContact {
  id: number
  email: string | null
  phoneNumber: string | null
  sendToPhone: boolean
  firstName: string
  lastName: string
  isPhoneBounced: boolean
  isEmailBounced: boolean
  doNotContact: boolean
  failureReason?: CustomMessageFailureReason
  loading?: boolean
}

export interface NotificationBlastPreviewOverview {
  smsCredits: number
  contacts: NotificationBlastContact[]
  negativeSmsCreditsLimit?: number
}

export default function useMessageOverview() {
  const organization = useCurrentOrg()
  return usePost<
    NotificationBlastPreviewOverview,
    { recipientPersonIds: number[]; emailsOnly?: boolean; textsOnly?: boolean }
  >({
    configMapper: ({
      recipientPersonIds,
      emailsOnly,
      textsOnly,
    }: {
      recipientPersonIds: number[]
      emailsOnly?: boolean
      textsOnly?: boolean
    }) => ({
      url: `/organizations/${organization.id}/notification-blast-overview`,
      config: { body: { recipientPersonIds, emailsOnly, textsOnly } },
    }),
    emptyValue: {
      smsCredits: 0,
      contacts: [],
    },
  })
}
